/**
 * Turn committed drawer filter state + search text + sort into flat query params
 * for the historical endpoints. Pure. Drops every empty value.
 *
 * committed: { [key]: Entry }
 *   categorical → { type:'categorical', value: string[] }
 *   numeric     → { type:'numeric',  min?: string, max?: string }
 *   datetime    → { type:'datetime', min?: string, max?: string }
 * search: string
 * sort:   { by: string, dir: 'asc'|'desc' } | null
 *
 * @returns {Record<string,string>}
 */
export function buildFilterParams(committed = {}, search = '', sort = null) {
  const params = {};

  for (const [key, entry] of Object.entries(committed)) {
    if (!entry) continue;
    if (entry.type === 'categorical') {
      const vals = (entry.value ?? []).filter((v) => v !== '' && v != null);
      if (vals.length) params[key] = vals.join(',');
    } else if (entry.type === 'numeric') {
      const min = (entry.min ?? '').toString().trim();
      const max = (entry.max ?? '').toString().trim();
      if (min !== '') params[`${key}_min`] = min;
      if (max !== '') params[`${key}_max`] = max;
    } else if (entry.type === 'datetime') {
      const min = (entry.min ?? '').toString().trim();
      const max = (entry.max ?? '').toString().trim();
      if (min !== '') {
        const minDate = new Date(min);
        if (!isNaN(minDate.getTime())) {
          params[`${key}_min`] = minDate.toISOString();
        }
      }
      if (max !== '') {
        const maxDate = new Date(max);
        if (!isNaN(maxDate.getTime())) {
          params[`${key}_max`] = maxDate.toISOString();
        }
      }
    }
  }

  const s = (search ?? '').trim();
  if (s !== '') params.search = s;

  if (sort && sort.by && sort.dir) {
    params.sortBy = sort.by;
    params.sortDir = sort.dir;
  }

  return params;
}
